import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { OverlayLoadingState } from '@app/selectors/overlay-loading.selector';
import { PdtDetailState, getPdtInfo } from '@app/selectors/shoppingmall/pdt-detail.selector';
import { ConvertUtil } from '@app/common/util/convert.util';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { loadPdtImages, loadPdtInfo, loadPdtNotify } from '@app/actions/shoppingmall/pdt-detail.action';
import { ProductState } from '@app/selectors/shoppingmall/product.selector';
import { setKeySearch, setPdtCate } from '@app/actions/shoppingmall/product.action';
import { getSmWownet, SmWownetState } from '@app/selectors/system/sm-wownet.selector';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { ValidationUtil } from '@app/common/util/validation.util';
import { AuthUtil } from '@app/common/util/auth.util';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PdtDetailModel } from '@app/models/shoppingmall/pdt-detail.model';
import { CustomerPrice } from '@app/pipes/customer-price.pipe';
import { WishListPdtService } from '@app/services/shoppingmall/wishlist-pdt.service';
import { PdtWishListState, getWishlist } from '@app/selectors/shoppingmall/wishlist-pdt-selector';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.css'],
  providers: [CustomerPrice]
})






export class ProductDetailComponent implements OnInit, OnDestroy {

  smWownet$ = new Observable<SmWownetModel>();

  quantity: number = 1;
  total: number = 0;

  wishYn: string = 'N';

  pdtInfo$ = new Observable<PdtDetailModel>();
  pdtInfo: PdtDetailModel = {} as PdtDetailModel;

  productWishYN: Map<string, string> = new Map();
	productWishYN$ = new Observable<Map<string, string>>();

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _overlayLoadingStore: Store<OverlayLoadingState>,
    private _pdtDetailStore: Store<PdtDetailState>,
    private _productStore: Store<ProductState>,
    private _smWownetStateStore: Store<SmWownetState>,
    private _deviceService: DeviceDetectorService,
    private _custPrice: CustomerPrice,
    private _wishListService: WishListPdtService,
		private _wishListStore: Store<PdtWishListState>,
  ) { 
    this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
    this.pdtInfo$ = this._pdtDetailStore.select(getPdtInfo);
    this.productWishYN$ = this._wishListStore.select(getWishlist);
  }

  ngOnInit(): void {
    this.smWownet$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        if(!AuthUtil.isLogined() && res.lShowPdtYn !== "Y"){
          this._router.navigate(["/login"]);
        }
      }
    });

    this._activatedRoute.paramMap.subscribe((params: ParamMap) => {
      let pdtCd = ConvertUtil.convertToSring(params.get("pdtCd"));
      let pathKind = this._deviceService.isDesktop() ? 'PC' : 'PHONE';

      this._overlayLoadingStore.dispatch(setShowOverlayLoading({ loading: true }));
      this._pdtDetailStore.dispatch(loadPdtInfo({ pdtCd }));
      this._pdtDetailStore.dispatch(loadPdtImages({ pdtCd, pathKind }));
      this._pdtDetailStore.dispatch(loadPdtNotify({ pdtCd }));
      setTimeout(() => {
        this._productStore.dispatch(setKeySearch({ key: "" }));
      }, 100);
    }); 

    this.pdtInfo$.subscribe(res => {
      if (ValidationUtil.isNotNullAndNotEmpty(res)) {
        this._productStore.dispatch(setPdtCate({ cate: ConvertUtil.convertToSring(res.cateCd) }));
        this.pdtInfo = res;
        this.total = +(this._custPrice.transform(res.retailAmt, res.amt));
        this.wishYn = res.wishYN+'';
      }
    });
  }

  ngOnDestroy(): void {
    this._productStore.dispatch(setPdtCate({ cate: "" }));
    this._pdtDetailStore.dispatch(loadPdtInfo({ pdtCd: "" }));
  }

  handleOnClickPlus(flag: string): void {
    this.quantity++;
    this.total = +(this._custPrice.transform(this.pdtInfo.retailAmt, this.pdtInfo.amt)) * this.quantity;
    
  }

  handleOnClickMinus(flag: string): void {
    if (this.quantity === 1) return;

    this.quantity--;
    this.total = +(this._custPrice.transform(this.pdtInfo.retailAmt, this.pdtInfo.amt)) * this.quantity;
  }

  onClickWishList(wishYn: string): void {

		this.wishYn = this._wishListService.addWishList(
			ConvertUtil.convertToSring(this.pdtInfo.pdtCd),
			wishYn
		);
	}
}
